import type { ReactNode } from 'react'

import { LanguageMenu } from '../LanguageMenu'
import { CheckoutHeader, CheckoutLanguage, CheckoutWrapper } from './CheckoutContainer.styled'

import LogoImage from '../../assets/images/the-kingdom-bank.svg'

type CheckoutContainerProps = {
  children: ReactNode
}

export const CheckoutContainer = ({ children }: CheckoutContainerProps) => (
  <CheckoutWrapper>
    <CheckoutHeader>
      <span className='logo'>
        <img src={LogoImage} alt='Logo' />
      </span>
    </CheckoutHeader>
    <CheckoutLanguage>
      <LanguageMenu />
    </CheckoutLanguage>
    {children}
  </CheckoutWrapper>
)
